class ProductForm extends HTMLElement {
  constructor() {
    super();   
   
    this.form = this.querySelector('form');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.cartMini = document.querySelector('cart-mini');
  }

  sellingPlanSelected() {
    const loopProductForm = this.querySelector('form[data-loop-product-id]');
    if(loopProductForm){
    const sellingPlanEle = loopProductForm.querySelector('input[name="selling_plan"]');
    const selling_plan = sellingPlanEle?.value;
    console.log('SELLING PLAN VALUE: ', selling_plan);
      if(selling_plan !== 0) {
          return true;
      }
    }
    return false;
  }  

  plpAddToBagEvent(form, e) {
    console.log(form);
    if(form.closest('.product-grid-item')) {
      let title = form.closest('.product-grid-item').querySelector('.product-grid-item__title a').innerText;
      if(window.gtag) {
        gtag("event", "PLP Add To Cart", {
          page_url: window.location.href,
          product_title: title
        });  
      }
    }
  }


  onSubmitHandler(evt) {
    evt.preventDefault();
    this.plpAddToBagEvent(this, evt);
    const submitButton = this.querySelector('[type="submit"]');

    console.log("SUBMIT HANDLER");
    let loaderHtml = '<div class="lds-ring"><div></div><div></div><div></div><div></div></div>';

    if(this.getAttribute('data-update-button') == "true") {
      submitButton.innerHTML = loaderHtml;
    }

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    var serializedForm = window.serializeForm(this.form);
    var formObject = JSON.parse(serializedForm);
    console.log("formObject", formObject);

    var gcform = this.form.querySelector('#gift-card-message');
    if(gcform != null) {

      formObject['properties'] = {
          "To": this.form.querySelector('#to').value,
          "From": this.form.querySelector('#from').value,
          "Message": this.form.querySelector('#message').value,
        };
    }

    if(formObject.gwp_product_tag_present || formObject.manual_gwp) {
      var items;
      const isSubscriptionPage = document.getElementById('subscribe-amp-save') ? true : false;

      if(this.sellingPlanSelected()) {
        const loopProductForm = this.querySelector('form[data-loop-product-id]');
        if(loopProductForm){
          const sellingPlanEle = loopProductForm.querySelector('input[name="selling_plan"]');
          window.gwp_selling_plan = sellingPlanEle?.value;
        }
        items = [
          {
            quantity: formObject['quantity'],
            id: formObject['id'],
            properties: {
              "_Gift With Purchase": "True"
            },
            selling_plan: window.gwp_selling_plan
          }
        ]
      }
      else if(isSubscriptionPage) {
        let sellingPlan = this.querySelector('#selling_plan').value;
        if(sellingPlan) {
          items = [
            {
              quantity: formObject['quantity'],
              id: formObject['id'],
              properties: {
                "_Gift With Purchase": "True"
              },
              selling_plan: sellingPlan
            }
          ]
        }
      }
      // handle add to cart when manual GWP is enabled
      else if(formObject.manual_gwp) {
        var selectedVariantIndex = document.querySelector('.cart-manual-gwp-dropdown').selectedIndex;
        var selectedVariantId = document.querySelectorAll('.cart-manual-gwp-dropdown option')[selectedVariantIndex].getAttribute("data-variant");
        console.log("Selected variant id:", selectedVariantId);
        // window.manual_gwp_selected_variant = selectedVariantId;
        console.log('MANUAL GWP BLOCK');
        items = [
          {
            quantity: 1,
            id: selectedVariantId,
            properties: {
              "_Free Gift": "Yes"
            }
          }
        ];
      }
      else {
        items = [
          {
            quantity: formObject['quantity'],
            id: formObject['id'],
            properties: {
              "_Gift With Purchase": "True",
            }
          }
        ]
      }

      if (formObject['properties[_tontinePriceVariant]']) {
        items[0].properties = {
          ...items[0].properties,
          "_tontinePriceVariant": formObject['properties[_tontinePriceVariant]'],
          "_tontineBValue": formObject['properties[_tontineBValue]'],
        }
      }

      var body = {
        items: items
      }

      console.log("SELLING PLAN:", window.gwp_selling_plan);
      console.log('BODY', body);
      fetch(`/cart/add.js`, { 
        body: JSON.stringify(body),
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With':'xmlhttprequest'
        },
        method: 'POST'
      })
      .then((response) => response.json())
      .then((parsedState) => {
        document.dispatchEvent(new Event('productAddSuccess'));
        document.dispatchEvent(Events().itemAdded._event(parsedState));
        console.log("PARSED", parsedState);
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        this.cartMini.setAttribute('data-updating', "updated");
        
        if(this.getAttribute('data-update-button') == "true") {
          submitButton.innerText = "ADDED";
          
        }else{
          submitButton.removeAttribute('disabled');
        }
        if(this.classList.contains('cart-cross-sell__form')){
          this.closest('cart-mini').scrollTop = 0;
        }
      });

      return;
    }

    var body = JSON.stringify(formObject);

    fetch(`${window.routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      .then((response) => response.json())
      .then((parsedState) => {
        document.dispatchEvent(new Event('productAddSuccess'));
        document.dispatchEvent(Events().itemAdded._event(parsedState));
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        submitButton.classList.remove('loading');
        this.cartMini.setAttribute('data-updating', "updated");
        
        if(this.getAttribute('data-update-button') == "true") {
          submitButton.innerText = "Added";
          
        }else{
          submitButton.removeAttribute('disabled');
        }
        if(this.classList.contains('cart-cross-sell__form')){
          this.closest('cart-mini').scrollTop = 0;
        }
      });
  }
}

customElements.define('product-form', ProductForm);
